"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _params = require("hub-http/helpers/params");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _Categories = _interopRequireDefault(require("./constants/Categories"));

var _DesignAssetTypes = _interopRequireDefault(require("./constants/DesignAssetTypes"));

var _enviro = _interopRequireDefault(require("enviro"));

var _iconUrl = require("content-icons-ui/iconUrl");

var _IconSets = require("ContentUtils/constants/IconSets");

var _Domains = require("./constants/Domains");

var SITE_PAGE_SUBCATEGORIES = ['site_page', 'mab_site_page_master', 'mab_site_page_variant'];

var isSitePage = function isSitePage(subcategoryId) {
  return typeof subcategoryId === 'string' && SITE_PAGE_SUBCATEGORIES.includes(subcategoryId.toLowerCase());
}; // Used to allow returning to original page whne navigating to a settings page.


var ESHREF_PARAM = "eschref=" + encodeURIComponent(window.location.pathname);
var Routes = {
  gates: null,
  optinMap: {},
  hasInitialized: false,
  init: function init(nextGates) {
    var optinMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Routes.gates = nextGates;
    Routes.optinMap = optinMap;
    Routes.hasInitialized = true;
  },
  isUngated: function isUngated(gateName) {
    if (!Array.isArray(Routes.gates)) {
      throw new Error('Routes needs to be initialized with an array of gates before using');
    }

    return Routes.gates.indexOf(gateName) > -1;
  },
  isOptedIn: function isOptedIn(optinName) {
    if (!Routes.optinMap) {
      throw new Error('Initialized map with falsey value');
    }

    return !!Routes.optinMap[optinName];
  },
  dashboard: function dashboard(categoryId, subcategoryId, parentId) {
    var category = _Categories.default[categoryId];
    var slug = category.api_slug;

    if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name)) {
      if (category.field_name === 'site_page' || isSitePage(subcategoryId)) {
        return "/website/" + _PortalIdParser.default.get() + "/pages/site";
      } else if (category.field_name === 'landing_page') {
        return "/website/" + _PortalIdParser.default.get() + "/pages/landing";
      } else if (category.field_name === 'blog_post') {
        var baseUrl = "/website/" + _PortalIdParser.default.get() + "/blog/posts";
        return parentId ? baseUrl + "?blog=" + parentId : baseUrl;
      }

      return "/website/" + _PortalIdParser.default.get();
    }

    if (isSitePage(subcategoryId)) {
      slug = _Categories.default.site_page.api_slug;
    }

    if (category.field_name === 'email') {
      return Routes.emailDashboard();
    }

    return "/content/" + _PortalIdParser.default.get() + "/" + slug;
  },
  blogImporter: function blogImporter() {
    return "/content/" + _PortalIdParser.default.get() + "/blog-import";
  },
  siteImporter: function siteImporter() {
    return "/site-importer/" + _PortalIdParser.default.get() + "/blog-import/dashboard";
  },
  blogOnboarding: function blogOnboarding() {
    return "/blog-onboarding/" + _PortalIdParser.default.get() + "/wizard";
  },
  emailDashboard: function emailDashboard() {
    return "/email/" + _PortalIdParser.default.get() + "/manage";
  },
  // categoryId can be category_id int or python's Category.field_name (email|blog_post|landing_page)
  edit: function edit(contentId, categoryId) {
    return Routes.inpageEdit(contentId, categoryId);
  },
  editDragDropEmail: function editDragDropEmail(contentId) {
    return this.editEmail(contentId);
  },
  editEmail: function editEmail(contentId) {
    return "/email/" + _PortalIdParser.default.get() + "/edit/" + contentId;
  },
  inpageEdit: function inpageEdit(contentId, categoryId) {
    var category = _Categories.default[categoryId] || {};

    switch (category.field_name) {
      case 'blog_post':
        return "/blog/" + _PortalIdParser.default.get() + "/edit-beta/" + contentId;

      case 'email':
        if (this.isOptedIn('mergedEmailEditor') && this.isUngated('Email:MergedEditorOptinSwitch')) {
          return this.editEmail(contentId);
        }

        return "/email/" + _PortalIdParser.default.get() + "/edit-beta/" + contentId;

      default:
        return "/content/" + _PortalIdParser.default.get() + "/edit/" + contentId;
    }
  },
  details: function details(contentId, categoryId, subcategory) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      tab: 'performance'
    },
        _ref$tab = _ref.tab,
        tab = _ref$tab === void 0 ? 'performance' : _ref$tab;

    var urlParamsString = params ? "?" + (0, _params.stringify)(params) : '';
    var category = _Categories.default[categoryId];

    if (category.field_name === 'unmapped') {
      return "/content-detail/" + _PortalIdParser.default.get() + "/external-page/optimization" + urlParamsString;
    } else if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name)) {
      var slugSource = isSitePage(subcategory) ? _Categories.default['site_page'] : category;
      return "/content-detail/" + _PortalIdParser.default.get() + "/" + slugSource.slug_singular + "/" + contentId + "/" + tab + urlParamsString;
    } else if (category.field_name === 'email') {
      return "/email/" + _PortalIdParser.default.get() + "/details/" + contentId + "/" + tab + urlParamsString;
    } else if (category.field_name === 'knowledge_article') {
      return "/knowledge/" + _PortalIdParser.default.get() + "/insights/article/" + contentId + "/" + tab + urlParamsString;
    }

    return "/content-detail/" + _PortalIdParser.default.get() + "/landing-page/" + contentId + "/" + tab + urlParamsString;
  },
  staging: function staging() {
    return "/content/" + _PortalIdParser.default.get() + "/staging";
  },
  stagingBeta: function stagingBeta(domainId) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/manage';
    return this.staging(domainId, route);
  },
  cta: function cta() {
    return "/cta/" + _PortalIdParser.default.get();
  },
  ctaDetails: function ctaDetails(placementGuid) {
    return "/cta/" + _PortalIdParser.default.get() + "/" + placementGuid;
  },
  ctaSmartRules: function ctaSmartRules(placementGuid) {
    return "/content/" + _PortalIdParser.default.get() + "/cta/" + placementGuid;
  },
  templateSwap: function templateSwap(categoryId, contentId) {
    if (!contentId) {
      throw new Error('A content id is required for template swap');
    }

    var category = _Categories.default[categoryId];

    if (category.slug_singular === 'site-page' || category.slug_singular === 'landing-page') {
      return "/create/" + _PortalIdParser.default.get() + "/" + category.slug_singular + "/your-themes?contentId=" + contentId + "&referrer=editpage";
    }

    throw new Error('Themed template swap can only used for pages');
  },
  create: function create(categoryId, subcategory) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$isMarketingStar = _ref2.isMarketingStarterPortal,
        isMarketingStarterPortal = _ref2$isMarketingStar === void 0 ? false : _ref2$isMarketingStar,
        _ref2$hasThemedConten = _ref2.hasThemedContentCreatorAccess,
        hasThemedContentCreatorAccess = _ref2$hasThemedConten === void 0 ? false : _ref2$hasThemedConten,
        _ref2$moduleIdForRevi = _ref2.moduleIdForReviewingDependents,
        moduleIdForReviewingDependents = _ref2$moduleIdForRevi === void 0 ? null : _ref2$moduleIdForRevi,
        _ref2$moduleName = _ref2.moduleName,
        moduleName = _ref2$moduleName === void 0 ? '' : _ref2$moduleName;

    var category = isSitePage(subcategory) ? _Categories.default.site_page : _Categories.default[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    if (category.slug_singular !== 'email' && hasThemedContentCreatorAccess && Routes.isUngated('cms-themed-content-creator')) {
      return "/create/" + _PortalIdParser.default.get() + "/" + category.slug_singular;
    }

    var createUrl = "/content/" + _PortalIdParser.default.get() + "/create/" + category.slug_singular;

    if (category.slug_singular !== 'email' && isMarketingStarterPortal) {
      return createUrl + "/starter";
    }

    if (category.slug_singular === 'email') {
      if (moduleIdForReviewingDependents) {
        return createUrl + "?subcategory=drag_drop_email&moduleId=" + moduleIdForReviewingDependents + "&moduleName=" + moduleName;
      } else if (subcategory === 'drag_drop_email') {
        return createUrl + "?subcategory=drag_drop_email";
      }
    }

    return createUrl;
  },
  createNew: function createNew(categoryId, subcategory, name, templatePath) {
    /* Create new only available in create-beta */
    var portalId = _PortalIdParser.default.get();

    var category = subcategory === 'landing_page' ? _Categories.default.landing_page : _Categories.default[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    return "/content/" + portalId + "/create/" + category.slug_singular + "/new?name=" + name + "&templatePath=" + templatePath;
  },
  settings: function settings(subsection) {
    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var portalId = _PortalIdParser.default.get();

    var baseURL = "/settings/" + portalId + "/";

    switch (subsection) {
      case 'email':
        {
          var emailBase = baseURL + "marketing/email/";

          switch (tab) {
            case 'frequency':
              return emailBase + "frequency";

            case 'subscriptions':
              return emailBase + "subscriptions";

            case 'types':
              return emailBase + "types";

            case 'tracking':
              return emailBase + "tracking";

            case 'double-opt-in':
              return emailBase + "double-opt-in";

            default:
              return emailBase;
          }
        }

      case 'blog':
        {
          return baseURL + "website/blogs" + (tab ? "/" + tab : '');
        }

      case 'publishing':
        {
          return baseURL + "website/pages";
        }

      case 'users':
        return baseURL + "users";

      case 'domains':
        {
          if (tab === 'languageSettings') {
            return baseURL + "marketing/domains/languageSettings";
          }

          return "/domains/" + portalId;
        }

      case 'themes':
        return baseURL + "website/themes";

      default:
        return baseURL;
    }
  },
  privateContentSettings: function privateContentSettings(tab) {
    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all-domains';
    return "/settings/" + _PortalIdParser.default.get() + "/content-membership/" + domain + "/" + tab;
  },
  systemPagesSettings: function systemPagesSettings(domain) {
    var basePagesUrl = Routes.settings('publishing');

    var __domain = domain || "all-domains";

    return basePagesUrl + "/" + __domain + "/system-pages?" + ESHREF_PARAM;
  },
  logoSettings: function logoSettings(domain) {
    var portalId = _PortalIdParser.default.get();

    var __domain = domain || "all-domains";

    return "/settings/" + portalId + "/website/pages/" + __domain + "/branding?" + ESHREF_PARAM;
  },
  blogSpecificSettings: function blogSpecificSettings(blogId) {
    var subTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Routes.settings('blog') + "/" + blogId + subTab + "?" + ESHREF_PARAM;
  },
  advancedMenuSettings: function advancedMenuSettings(menuId, redirectUrl) {
    var basePath = "/menus/" + _PortalIdParser.default.get() + "/edit/" + menuId;

    if (redirectUrl) {
      return basePath + "?redirectUrl=" + encodeURIComponent(redirectUrl);
    }

    return basePath;
  },
  advancedMenuAddPage: function advancedMenuAddPage(pageId) {
    return "/content/" + _PortalIdParser.default.get() + "/settings/menus/add-page?contentId=" + pageId + "&" + ESHREF_PARAM;
  },
  designManager: function designManager(assetId, assetType, assetSource, path) {
    var route = "/design-manager/" + _PortalIdParser.default.get();

    if (assetId && assetType) {
      var urlPath;

      switch (assetType) {
        case _DesignAssetTypes.default.LAYOUT:
        case _DesignAssetTypes.default.GLOBAL_GROUP:
          {
            urlPath = "templates/" + assetId;
            break;
          }

        case _DesignAssetTypes.default.TEMPLATE:
          {
            if (assetSource === 'HOLLOW') {
              urlPath = "code/p/" + path;
            } else {
              urlPath = "code/" + assetId;
            }

            break;
          }

        case _DesignAssetTypes.default.CUSTOM_WIDGET:
          {
            urlPath = "modules/" + assetId;
            break;
          }

        case _DesignAssetTypes.default.GLOBAL_WIDGET:
          {
            urlPath = "global-modules/" + assetId;
            break;
          }

        default:
          {
            throw new Error("Invalid Design Manager assetType provided. Received '" + assetType + "'.");
          }
      }

      route = route + "/" + urlPath;
    }

    return route;
  },
  globalContent: function globalContent(moduleId) {
    if (moduleId) {
      return Routes.designManager(moduleId, _DesignAssetTypes.default.GLOBAL_WIDGET);
    }

    if (Routes.isUngated('DesignManagerUI:GlobalContent:Redirect')) {
      return Routes.designManager() + "?referrer=global-content";
    }

    return "/content/" + _PortalIdParser.default.get() + "/global-content";
  },
  fileManager: function fileManager(folderPath, params) {
    var path = "/files/" + _PortalIdParser.default.get();

    if (folderPath) {
      path = path + "/folder/" + folderPath.replace(/^\//, '');
    }

    if (params) {
      path = path + "?" + (0, _params.stringify)(params);
    }

    return path;
  },
  hubdb: function hubdb() {
    return "/hubdb/" + _PortalIdParser.default.get();
  },
  hubdbTable: function hubdbTable(tableId) {
    return this.hubdb() + "/table/" + tableId;
  },
  workflows: function workflows(workflowId) {
    var workflowType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'WORKFLOWS';

    if (workflowType === 'AUTOMATION_PLATFORM') {
      return "/workflows/" + _PortalIdParser.default.get() + "/platform/flow/" + workflowId + "/edit";
    }

    return "/contacts/" + _PortalIdParser.default.get() + "/automation/flow/" + workflowId + "/edit/";
  },
  workflowsDashboard: function workflowsDashboard() {
    return "/contacts/" + _PortalIdParser.default.get() + "/automation";
  },
  contact: function contact(vid) {
    return "/contacts/" + _PortalIdParser.default.get() + "/contact/" + vid;
  },
  deal: function deal(dealId) {
    return "/contacts/" + _PortalIdParser.default.get() + "/deal/" + dealId;
  },
  forms: function forms(formId, redirectUrl) {
    var extraParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var basePath = "/forms/" + _PortalIdParser.default.get() + "/editor/" + formId + "/edit/form";
    var params = Object.assign({}, extraParams, {}, redirectUrl ? {
      redirectUrl: redirectUrl,
      isExternalEditor: 'cos'
    } : {});
    var paramsAsString = (0, _params.stringify)(params);
    return paramsAsString.length > 0 ? basePath + "?" + paramsAsString : basePath;
  },
  salesforceCampaigns: function salesforceCampaigns() {
    return "/integrations-beta/" + _PortalIdParser.default.get() + "/your-integrations/salesforce";
  },
  domainManager: function domainManager() {
    return "/domains/" + _PortalIdParser.default.get();
  },
  leadFlowFollowup: function leadFlowFollowup(leadFlowId) {
    return "/lead-flows/" + _PortalIdParser.default.get() + "/edit/" + leadFlowId + "/follow-up";
  },
  formFollowup: function formFollowup(formId) {
    return "/forms/" + _PortalIdParser.default.get() + "/editor/" + formId + "/edit/followUp";
  },
  emailCompare: function emailCompare() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (ids.length > 0) {
      return "/email/" + _PortalIdParser.default.get() + "/compare?id=" + ids.join('&id=');
    }

    return "/email/" + _PortalIdParser.default.get() + "/compare";
  },
  surveyEditor: function surveyEditor(surveyType, surveyId) {
    var surveyTypePath = {
      CES: 'support',
      NPS: 'loyalty',
      CSAT: 'satisfactions'
    }[surveyType];
    return "/feedback-editor/" + _PortalIdParser.default.get() + "/" + surveyTypePath + "/" + surveyId;
  },
  marketplace: function marketplace(urlToken, redirectUrl) {
    var marketplaceRoute = "/marketplace/" + _PortalIdParser.default.get();

    return urlToken ? marketplaceRoute + "/products/" + urlToken + (redirectUrl ? "?redirectUrl=" + encodeURIComponent(redirectUrl) : '') : marketplaceRoute;
  },
  marketingHubPricingPage: function marketingHubPricingPage() {
    return "/pricing/" + _PortalIdParser.default.get() + "/products/marketing";
  },
  compareMarketingProducts: function compareMarketingProducts(product) {
    var portalId = _PortalIdParser.default.get();

    var queryString = '';

    if (product) {
      queryString = "?product=" + product;
    }

    return "/browse/" + portalId + "/compare/marketing" + queryString;
  },
  accountSummary: function accountSummary() {
    var portalId = _PortalIdParser.default.get();

    return "/account-and-billing/" + portalId + "/products";
  },
  accountUsage: function accountUsage() {
    var portalId = _PortalIdParser.default.get();

    return "/account-and-billing/" + portalId + "/usage";
  },
  additionalContact: function additionalContact() {
    var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var portalId = _PortalIdParser.default.get();

    return "/pricing/" + portalId + "/confirm-contacts" + queryParams;
  },
  campaignDetails: function campaignDetails(campaignId) {
    var portalId = _PortalIdParser.default.get();

    return "/campaigns/" + portalId + "/" + campaignId;
  },
  goToWebinar: function goToWebinar() {
    return "/integrations-beta/" + _PortalIdParser.default.get() + "/your-integrations/gotowebinar";
  },
  list: function list(listId) {
    return "/contacts/" + _PortalIdParser.default.get() + "/lists/" + listId;
  },
  lists: function lists() {
    // Not lists UI but CRM contact filter view
    return "/contacts/" + _PortalIdParser.default.get() + "/contacts/list/view/all";
  },
  newList: function newList() {
    return "/contacts/" + _PortalIdParser.default.get() + "/lists/create";
  },
  getPreviewDomain: function getPreviewDomain() {
    var env = _enviro.default.getShort('preview');

    if (env !== 'local') {
      return _Domains.PREVIEW_DOMAINS[env];
    }

    try {
      return localStorage.getItem('PREVIEW_DOMAIN') || _Domains.PREVIEW_DOMAINS[env];
    } catch (e) {
      return _Domains.PREVIEW_DOMAINS[env];
    }
  },
  getPreviewUrl: function getPreviewUrl(contentId, extraParams) {
    var env = _enviro.default.getShort('preview');

    var params = Object.assign({
      portalId: _PortalIdParser.default.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "?" + (0, _params.stringify)(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "?" + (0, _params.stringify)(params);
  },
  getVideoPreviewUrl: function getVideoPreviewUrl(playerId, extraParams) {
    var params = Object.assign({
      portalId: _PortalIdParser.default.get()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();
    return "https://" + previewDomain + "/content-rendering/v1/internal/preview/player/" + playerId + "?" + (0, _params.stringify)(params);
  },
  getPreviewSidebarUrl: function getPreviewSidebarUrl(contentId, extraParams) {
    var env = _enviro.default.getShort('preview');

    var params = Object.assign({
      portalId: _PortalIdParser.default.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "/sidebar?" + (0, _params.stringify)(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "/sidebar?" + (0, _params.stringify)(params);
  },
  themes: function themes() {
    return this.settings('themes') + "?" + ESHREF_PARAM;
  },
  themeEditor: function themeEditor(themePath, params) {
    var route = "/theme-editor/" + _PortalIdParser.default.get() + "/edit/" + themePath;
    if (params) route = route + "?" + (0, _params.stringify)(params);
    return route;
  },
  globalContentEditor: function globalContentEditor(globalContentId, params) {
    var _ref3 = params || {},
        assetPath = _ref3.assetPath;

    if (!(globalContentId || assetPath)) {
      throw new Error('Global content ID or asset path required to load editor.');
    }

    var route = "/global-content-editor/" + _PortalIdParser.default.get() + "/edit";
    if (globalContentId) route = route + "/" + globalContentId;
    if (params) route = route + "?" + (0, _params.stringify)(params);
    return route;
  },
  createTeamMeeting: function createTeamMeeting() {
    return "/meetings/" + _PortalIdParser.default.get() + "/team/new";
  },
  createPersonalMeeting: function createPersonalMeeting() {
    return "/meetings/" + _PortalIdParser.default.get() + "/personal/new";
  },
  editMeeting: function editMeeting(portalId, meetingId) {
    return "/meetings/" + portalId + "/personal/" + meetingId;
  },
  getContentIconsUrl: function getContentIconsUrl(set, iconName, style) {
    if (!set || !_IconSets.ICON_SETS[set]) set = _IconSets.DEFAULT_ICON_SET;
    return (0, _iconUrl.getIconUrl)(set, iconName, style);
  },
  blogDashboard: function blogDashboard(contentGroupId) {
    if (contentGroupId) {
      return "/blog/" + _PortalIdParser.default.get() + "/blogs/posts?blog=" + contentGroupId;
    }

    return "/blog/" + _PortalIdParser.default.get();
  },
  accountDefaults: function accountDefaults(path) {
    return "/settings/" + _PortalIdParser.default.get() + "/account-defaults/" + path;
  }
};
var _default = Routes;
exports.default = _default;
module.exports = exports.default;